module.exports = __webpack_public_path__ + "img/ambulance_h.c07efa75.png";